import { useTranslation } from 'react-i18next';
import { Form } from 'antd';
import { useTransportLoadFiltersStore } from 'shared/stores/use-transport-load-filters';
import { disablePickerComparisonDate } from 'shared/utils/date-picker/disable-picker-comparison-dates';
import { transformAndSetFilters } from 'shared/utils/filters/transform-and-set-filters';
import { DataRangeFormPicker } from 'components/common/data-range-form-picker';
import { UserFormSelect } from 'components/common/user-form-select';
import { StatisticsDateRangePicker } from 'components/statistics/statistics-date-range-picker';
import styles from './transport-load-filters.module.scss';

export const TransportLoadFilters = () => {
  const { filters, setFilters } = useTransportLoadFiltersStore();
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const mainPeriod = Form.useWatch('date', form);

  const handleSuccess = () => {
    transformAndSetFilters(form, setFilters);
  };

  const handleMainPeriodChange = () => {
    form.setFieldValue('comparisonDate', null);
    handleSuccess();
  };

  const disabledComparisonDates = disablePickerComparisonDate(mainPeriod);

  return (
    <Form form={form} name='transport-load-filter' layout='horizontal' initialValues={filters} className={styles.form}>
      <UserFormSelect
        name='userId'
        label={t('common:manager')}
        placeholder={t('common:manager')}
        handleUserChange={handleSuccess}
        className={styles.formItem}
        required
      />
      <StatisticsDateRangePicker handleSuccess={handleMainPeriodChange} className={styles.formItem} />
      {mainPeriod && (
        <DataRangeFormPicker
          name='comparisonDate'
          label='Comparison period'
          className={styles.formItem}
          handleSuccess={handleSuccess}
          disabledDate={disabledComparisonDates}
        />
      )}
    </Form>
  );
};
